import React from "react";
import PropTypes from "prop-types";
import { ImageFallbackIcon } from "../../Svgs/fallbackImage";

import "./fallback.m.css";

export const FallbackImage = () => {
  return (
    <div styleName="image" className="arr--fallback-image">
      <figure styleName="fallback-svg" className="arr--fallback-svg">
        <ImageFallbackIcon />
      </figure>
    </div>
  );
};

FallbackImage.propTypes = {
  bgColor: PropTypes.object
};
